import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

const InputFilter = ({onSearch, value, type}) => {
    const {t} = useTranslation();

    const onInputChange = value => {
        onSearch(value);
    };
    return (
        <input
            type={type ? type : 'text'}
            className="block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-800 dark:border-gray-700"
            placeholder={t('filtro')}
            value={value}
            onChange={e => onInputChange(e.target.value)}
        />
    );
};

export default InputFilter;
